import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as RadixToast from '@radix-ui/react-toast';
import { Toast } from './Toast.jsx';
import { selectToasts } from '../features/system/store/selectors.js';
import { toastDismissed } from '../features/system/store/toastSlice.js';

export function ToastViewport() {
  const toasts = useSelector(selectToasts);
  const dispatch = useDispatch();
  const viewportRef = useRef(null);

  useEffect(() => {
    const viewport = viewportRef.current;
    if (!viewport) return undefined;

    // Radix dialogs listen at document level for outside interactions. Keep
    // toast input inside the viewport so a native touch close cannot also
    // dismiss an open dialog after the toast has unmounted.
    const containInteraction = (event) => event.stopPropagation();
    viewport.addEventListener('pointerdown', containInteraction);
    viewport.addEventListener('click', containInteraction);

    return () => {
      viewport.removeEventListener('pointerdown', containInteraction);
      viewport.removeEventListener('click', containInteraction);
    };
  }, []);

  return (
    <>
      {toasts.map((t) => (
        <Toast
          key={t.id}
          id={t.id}
          variant={t.variant}
          message={t.message}
          onDismiss={(id) => dispatch(toastDismissed(id))}
        />
      ))}
      <RadixToast.Viewport
        ref={viewportRef}
        data-toast-viewport=""
        className="fixed z-[120] flex flex-col gap-2 outline-none
                   bottom-[calc(env(safe-area-inset-bottom,0px)+12px)] left-1/2 -translate-x-1/2 w-[calc(100vw-24px)] max-w-sm
                   lg:bottom-4 lg:right-4 lg:left-auto lg:translate-x-0 lg:max-w-md"
      />
    </>
  );
}
